import styled from '@emotion/styled';
import { Button, WsColors } from 'wisestep-base';

const StyledButton = styled(Button)(({ remove }: { remove: boolean }) => ({
  color: remove ? WsColors.Red400 : WsColors.TheBlues400,
  textTransform: 'none',
}));

export default StyledButton;
